import { Grid, Skeleton } from '@mui/material';

export const PatientListLoading = () => {
  return (
    <Grid
      container
      p={{ xs: '0 12px', md: '0 0 0 48px' }}
      mt={{ md: 0, xs: 10 }}
    >
      <Grid item xs={12}>
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={'100%'}
          height={56}
          sx={{ borderRadius: '16px' }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        display="flex"
        justifyContent="space-between"
        mt="33px"
        mb="16px"
      >
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={210}
          height={30}
          sx={{ borderRadius: '16px' }}
        />
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={100}
          height={30}
          sx={{ borderRadius: '16px' }}
        />
      </Grid>
      {[...Array(4)].map((_, index) => (
        <Skeleton
          key={index}
          animation="wave"
          variant="rectangular"
          width={'100%'}
          height={86}
          sx={{ borderRadius: '16px', mb: '12px' }}
        />
      ))}
    </Grid>
  );
};
